!(function () {
  const t = (e) => {
      let a;
      (a = (document.currentScript ? document.currentScript.parentElement : e).querySelector(".popular-products__slider")) &&
          new IntersectionObserver((e) => {
              e.forEach((t) => {
                  if (t.isIntersecting) {
                      var t = a.parentElement.querySelector(".popular-products__navigation"),
                          r = a.querySelector(".popular-products__pagination"),
                          n = Number(a.dataset.columns),
                          s = 5 == n ? n - 1 : n,
                          i = 3 < n ? s - 1 : s,
                          o = 2 < n ? i - 1 : i;
                      let e = 1;
                      a.classList.contains("products--2-mobile") && (e = 1 < n ? 2 : 1);
                      new Swiper(a, {
                          slidesPerView: e,
                          slidesPerGroup: e,
                          spaceBetween: 8,
                          speed: 800,
                          navigation: { nextEl: t.querySelector(".swiper-button-next"), prevEl: t.querySelector(".swiper-button-prev") },
                          pagination: {
                              el: r,
                              type: "custom",
                              renderCustom: function (e, t, r) {
                                  let n = "";
                                  for (let e = 1; e < r + 1; e++)
                                      n =
                                          e == t
                                              ? `${n}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                                              : `${n}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
                                  return n;
                              },
                          },
                          breakpoints: {
                              576: { slidesPerView: o, slidesPerGroup: o, spaceBetween: 24 },
                              750: { slidesPerView: i, slidesPerGroup: i, spaceBetween: 24 },
                              1200: { slidesPerView: s, slidesPerGroup: s, spaceBetween: 24 },
                              1600: { slidesPerView: n, slidesPerGroup: n, spaceBetween: 24 },
                          },
                      });
                  }
              });
          }).observe(e || document.currentScript.parentElement);
  };
  t(),
      document.addEventListener("shopify:section:load", function (e) {
          t(e.target);
      });
})();
